import { createTheme, PaletteMode } from '@mui/material/styles';

// Create a theme instance for each mode
export const getTheme = (mode: PaletteMode) => createTheme({
  palette: {
    mode,
    primary: {
      main: mode === 'light' ? '#F8A5B6' : '#E68199', // softer pink in light mode, deeper in dark
      light: mode === 'light' ? '#FFDBE5' : '#F8A5B6',
      dark: mode === 'light' ? '#E68199' : '#D46A82',
      contrastText: mode === 'light' ? '#333' : '#fff',
    },
    secondary: {
      main: mode === 'light' ? '#D7E4C0' : '#B6C99A', // softer lime in light mode, deeper in dark
      light: mode === 'light' ? '#E9F0DC' : '#D7E4C0',
      dark: mode === 'light' ? '#B6C99A' : '#9AAF7C',
      contrastText: mode === 'light' ? '#333' : '#fff',
    },
    background: {
      default: mode === 'light' ? '#FEFBFC' : '#1A1A1A', // very subtle pink tint in light, dark gray in dark
      paper: mode === 'light' ? '#FFFFFF' : '#2D2D2D',
    },
    text: {
      primary: mode === 'light' ? '#3A3A3A' : '#F0F0F0',
      secondary: mode === 'light' ? '#666666' : '#B0B0B0',
    },
  },
  typography: {
    fontFamily: "'Nunito', 'Arial', sans-serif",
    h1: {
      fontWeight: 700,
      letterSpacing: '0.01em',
    },
    h2: {
      fontWeight: 700,
      letterSpacing: '0.01em',
    },
    h3: {
      fontWeight: 600,
    },
    h4: {
      fontWeight: 600,
    },
    h5: {
      fontWeight: 600,
    },
    h6: {
      fontWeight: 600,
    },
    button: {
      fontWeight: 600,
      textTransform: 'none',
      letterSpacing: '0.02em',
    },
    body1: {
      fontWeight: 400,
    },
    body2: {
      fontWeight: 400,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          padding: '8px 24px',
          boxShadow: 'none',
          '&:hover': {
            boxShadow: 'none',
          },
        },
        contained: {
          '&.MuiButton-containedPrimary': {
            backgroundColor: mode === 'light' ? '#F8A5B6' : '#E68199',
            '&:hover': {
              backgroundColor: mode === 'light' ? '#E68199' : '#D46A82',
            },
          },
          '&.MuiButton-containedSecondary': {
            backgroundColor: mode === 'light' ? '#D7E4C0' : '#B6C99A',
            '&:hover': {
              backgroundColor: mode === 'light' ? '#B6C99A' : '#9AAF7C',
            },
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: mode === 'light' 
            ? '0 4px 12px rgba(0,0,0,0.05)' 
            : '0 4px 12px rgba(0,0,0,0.2)',
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        standardInfo: {
          backgroundColor: mode === 'light' ? '#E9F0DC' : '#3A4A2E',
          color: mode === 'light' ? '#3A3A3A' : '#E9F0DC',
        },
        standardSuccess: {
          backgroundColor: mode === 'light' ? '#E9F0DC' : '#3A4A2E',
          color: mode === 'light' ? '#3A3A3A' : '#E9F0DC',
        },
      },
    },
    MuiDivider: {
      styleOverrides: {
        root: {
          borderColor: mode === 'light' ? '#E9F0DC' : '#3A4A2E',
          opacity: 0.7,
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 8,
            '&.Mui-focused fieldset': {
              borderColor: mode === 'light' ? '#D7E4C0' : '#9AAF7C',
            },
          },
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          '&.Mui-checked': {
            color: mode === 'light' ? '#D7E4C0' : '#9AAF7C',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: mode === 'light' 
            ? '0 4px 12px rgba(0,0,0,0.05)' 
            : '0 4px 12px rgba(0,0,0,0.2)',
        },
      },
    },
  },
}); 